<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>Scale weight field</h2>
            <p class="demo-description">
                <code>upp-scale-input</code> wraps <code>upp-input</code> for weight in grams.
                Without <code>connection</code> + <code>device</code> it behaves as a manual field.
                Live capture is owned by the caller (open WS, pass inputs, close WS on destroy).
            </p>

            <div class="demo-controls">
                <ion-button size="small" (click)="setSampleWeight()">Set 1250 g</ion-button>
                <ion-button size="small" color="medium" (click)="resetForm()">Reset</ion-button>
            </div>

            <div class="demo-section" [formGroup]="form" uppDataid="demo-scale-input">
                <upp-form-section title="Weight (grams)">
                    <ion-item>
                        <upp-scale-input
                            controlName="weight"
                            title="Weight"
                            placeholder="0"
                            type="number"
                            [kiosk]="false"
                            [connection]="connection"
                            [device]="device">
                        </upp-scale-input>
                    </ion-item>
                </upp-form-section>
                <p class="demo-hint">Current value: {{ form.get('weight')?.value ?? '—' }}</p>
            </div>
        </div>
    </upp-scrollable>
</div>
